import type { FC } from 'react';
import styled from 'styled-components';
import type { Match, WrestlerInMatch } from '../../../types';
import { AvatarOpponentBoxAvatar, BoxWinnerGeneric, DefaultContainerCard, TopDecorColor } from './GenericComponentCssMatchCard';
import CenterInfoFightComponentRender from './GenericComponentMatchCard';

const OpponentBox = styled.div`
    display: flex;
    flex-direction: row;
    /* justify-content: space-around; */
    padding: 0 30px;
    align-items: center;
    gap: 10px;
    width: 35%;

    & .opponent-name {
        font-size: 30px;
        font-weight: 500;
        margin: 0;
        text-transform: uppercase;
        width: calc(100% - 200px);
        padding: 0 30px;
        text-align: center;
        // spazio caratteri
        letter-spacing: 5px;
        // se supera il width va a capo
        white-space: normal;
        overflow-wrap: break-word;
    }
`;

interface SingleMatchCardProps {
    matchInfo: Match;
    keyMatchInfo: number | string;
    navigateToWrestler: (wrestler: WrestlerInMatch) => void;
}

const SingleMatchCard: FC<SingleMatchCardProps> = ({ matchInfo, keyMatchInfo, navigateToWrestler }) => {
    return (
        <DefaultContainerCard key={keyMatchInfo}>
            <TopDecorColor />

            <OpponentBox className="left-opponent-box">
                <AvatarOpponentBoxAvatar
                 className="avatar-opponent-box-avatar"
                 width="200px" height="200px"
                 onClick={() => navigateToWrestler(matchInfo.wrestlers[0])}>

                    <img src={process.env.REACT_APP_STORAGE_URL + matchInfo.wrestlers[0].avatar_path} alt={matchInfo.wrestlers[0].name} />
                    {matchInfo.wrestlers[0].pivot.is_winner ? (
                        <BoxWinnerGeneric>
                            <span className="winner-text">WIN</span>
                            {matchInfo.win_by_dq ?
                                <span className="by-dq">BY DQ</span>
                            : null}
                        </BoxWinnerGeneric>
                    ) : null}
                </AvatarOpponentBoxAvatar>
                <h2 className="opponent-name">{matchInfo.wrestlers[0].name}</h2>
            </OpponentBox>

            <CenterInfoFightComponentRender nameMatch="Single" matchInfo={matchInfo} />

            <OpponentBox className="right-opponent-box">
                <h2 className="opponent-name">{matchInfo.wrestlers[1].name}</h2>
                <AvatarOpponentBoxAvatar
                 className="avatar-opponent-box-avatar"
                 width="200px" height="200px"
                 onClick={() => navigateToWrestler(matchInfo.wrestlers[1])}
                >
                    <img src={process.env.REACT_APP_STORAGE_URL + matchInfo.wrestlers[1].avatar_path} alt={matchInfo.wrestlers[1].name} />
                    {matchInfo.wrestlers[1].pivot.is_winner ? (

                        <BoxWinnerGeneric>
                            <span className="winner-text">WIN</span>
                            {matchInfo.win_by_dq ?
                                <span className="by-dq">BY DQ</span>
                            : null}
                        </BoxWinnerGeneric>
                    ) : null}
                </AvatarOpponentBoxAvatar>
            </OpponentBox>
        </DefaultContainerCard>
    );
};

export default SingleMatchCard;
